import { Pipe, PipeTransform } from '@angular/core';

import {
  AxonViLPRCameraModel,
  AxonViLPRCameraModelDisplayName,
} from '../../models/axon-vi-lpr-camera-model.enum';

/** Maps Axon camera model enum values to display names (e.g., "Fleet 3 Hub", "Outpost", "Lightpost") */
@Pipe({
  name: 'fsAxonViLPRCameraModel',
  standalone: true,
})
export class AxonViLPRCameraModelMapperPipe implements PipeTransform {
  transform(value: AxonViLPRCameraModel): AxonViLPRCameraModelDisplayName | string {
    switch (value) {
      case AxonViLPRCameraModel.AXON_FLEET_3_HUB:
        return AxonViLPRCameraModelDisplayName.AXON_FLEET_3_HUB;
      case AxonViLPRCameraModel.AXON_OUTPOST:
        return AxonViLPRCameraModelDisplayName.AXON_OUTPOST;
      case AxonViLPRCameraModel.AXON_LIGHTPOST:
        return AxonViLPRCameraModelDisplayName.AXON_LIGHTPOST;
      default:
        return value;
    }
  }
}
